import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  /** Foto de perfil (URL completa). */
  photo?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  note?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  note,
  background = 'white'
}: TestimonialsProps) {
  return <section className={`w-full ${background === 'white' ? 'bg-white' : 'bg-ivory'} py-16 sm:py-20`} data-id="element-224" data-mp="36zqzn46rtjyx">
      <div className="mx-auto max-w-6xl px-5" data-id="element-225" data-mp="31yl4z0tjvmmr">
        {title && <>
            <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-226" data-mp="2x1l2ezvwt20e">
              {title}
            </h2>
            <div className="rule-gold mx-auto mt-6 w-32" aria-hidden="true" data-id="element-227" data-mp="2s3t8k0bpf5tk" />
          </>}

        <ul className={`grid gap-6 sm:grid-cols-3 ${title ? 'mt-12' : ''}`} data-id="element-228" data-mp="v7c9pfbt5ltm">
          {testimonials.map(testimonial => <li key={testimonial.quote} className="flex flex-col border border-gold-soft/70 bg-ivory p-7" data-id="element-229" data-mp="h5yamk89jn69">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-230" data-mp="m5t1ins1gcrb">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-231" data-mp="7a4ukqvc5bjq" data-mpi={index} />)}
              </div>

              <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-232" data-mp="14w29yfef50rg">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>

              <div className="mt-6 flex items-center gap-3 border-t border-gold-soft/70 pt-5" data-id="element-233" data-mp="q4s9yiczarni">
                {testimonial.photo ? <img src={testimonial.photo} alt={`Foto de ${testimonial.author}`} className="h-11 w-11 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-234" data-mp="1iv1xtku3xbmk" /> : <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold-tint font-serif text-sm text-gold-dark" aria-hidden="true" data-id="element-235" data-mp="1sj5vjitgkx2e">
                    {testimonial.author.charAt(0)}
                  </span>}
                <span data-id="element-236" data-mp="1ejeknqy8nwsm">
                  <span className="block text-sm font-semibold text-ink" data-id="element-237" data-mp="1ejwop9r57fb3">
                    {testimonial.author}
                  </span>
                  {testimonial.role && <span className="block text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-238" data-mp="14ud86aqwjxje">
                      {testimonial.role}
                    </span>}
                </span>
              </div>
            </li>)}
        </ul>

        {note && <p className="mx-auto mt-10 max-w-3xl text-center text-[13px] leading-relaxed text-ink-muted" data-id="element-239" data-mp="qtakjtk9ef6d">
            {note}
          </p>}
      </div>
    </section>;
}